import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { AuthStore } from 'src/core/stores';
import {
  CoreUsersService,
  UpdateUserDto,
  UserDto,
} from 'src/generated/api/nestjs-backend';
import { DialogComponent } from '../../shared/dialog/dialog.component';

@Component({
  selector: 'core-activate-user-dialog',
  templateUrl: './activate-user-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogComponent],
})
export class ActivateUserDialogComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private elementRef = inject(ElementRef);
  private authStore = inject(AuthStore);
  private coreUsersService = inject(CoreUsersService);

  @ViewChild(DialogComponent) dialogComponent!: DialogComponent;
  @Output() save: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Input() user!: UserDto;
  public onClose = new EventEmitter<boolean>();
  public dialogTitle = '';
  public dialogSubtitle = '';
  public dialogConfirmButtonText = '';
  public dialogCancelButtonText = '';

  ngOnInit() {
    if (this.user.isActive) {
      this.dialogTitle = 'user-management-deactivate-dialog-title';
      this.dialogSubtitle = 'user-management-deactivate-dialog-subtitle';
      this.dialogConfirmButtonText = 'core.buttons.deactivate';
      this.dialogCancelButtonText = 'core.buttons.cancel';
    } else {
      this.dialogTitle = 'user-management-activate-dialog-title';
      this.dialogSubtitle = 'user-management-activate-dialog-subtitle';
      this.dialogConfirmButtonText = 'core.buttons.activate';
      this.dialogCancelButtonText = 'core.buttons.cancel';
    }
  }

  ngOnDestroy() {
    this.elementRef.nativeElement.remove();
  }

  ngAfterViewInit() {
    this.dialogComponent.onOpen();
  }

  onSave() {
    this.toggleUserActiveOrInactive();
  }

  closeModal(success: boolean) {
    this.onClose.emit(success);
  }

  private toggleUserActiveOrInactive() {
    const updatedUser: UpdateUserDto = {
      isActive: !this.user.isActive,
    };

    this.coreUsersService
      .updateUser({
        xTenantSlug: this.authStore.tenantSlug(),
        userUuid: this.user?.uuid,
        updateUserDto: updatedUser,
      })
      .subscribe({
        next: () => {
          this.closeModal(true);
        },
        error: (error) => {
          console.error(
            'Error while toggling user active status: ',
            error.error?.message,
          );
        },
      });
  }
}
